// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lt-0";
export var fileList = "_lt-2";
export var removeFileButton = "_lt-1";